import Vue from 'vue'
import Router from 'vue-router'
import Startpage from '@/components/Startpage'
import Error from '@/components/Error'
import ErrorContent from '@/components/ErrorContent'
import Faq from '@/components/Faq'
import ConfirmNumber from '@/components/ConfirmNumber'
import EnterCode from '@/components/EnterCode'
import EnterSSN from '@/components/EnterSSN'
import ScrSex from '@/components/ScrSex'
import ScrCountry from '@/components/ScrCountry'
import ScrRegion from '@/components/ScrRegion'
import ScrNeedle from '@/components/ScrNeedle'
import OffSthlm from '@/components/OffSthlm'
import Consent from '@/components/Consent'
import Sampling from '@/components/Sampling'
import TestResult from '@/components/TestResult'
import LoginTestResult from '@/components/Login_TestResult'
import LoginConfirm from '@/components/Login_Confirm'
import LoginEnterCode from '@/components/Login_EnterCode'
import { handleSessionIdQueryParam } from '../plugins/queryparam'

// Silences NavigationDuplicated error
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'startpage',
      component: Startpage,
      meta: {}
    },
    {
      path: '*', // all other paths,
      name: 'error', // goes to this,
      component: Error, // since most components are routed,
      meta: {}, // and neccessary for the application.
      props: true
    },
    {
      path: '/errorcontent',
      name: 'errorcontent',
      component: ErrorContent,
      meta: {},
      props: true
    },
    {
      path: '/faq/:page',
      name: 'faq',
      component: Faq,
      props: true
    },
    {
      path: '/cnfrm',
      name: 'confirm',
      component: ConfirmNumber,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/entercode',
      name: 'entercode',
      component: EnterCode,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/enterssn',
      name: 'enterssn',
      component: EnterSSN,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: true
      }
    },
    {
      path: '/scr-s',
      name: 'scrsex',
      component: ScrSex,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/scr-c',
      name: 'scrcountry',
      component: ScrCountry,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/scr-r',
      name: 'scrregion',
      component: ScrRegion,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/scr-n',
      name: 'scrneedle',
      component: ScrNeedle,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/off',
      name: 'offsthlm',
      component: OffSthlm,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/cnsnt',
      name: 'consent',
      component: Consent,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/sampling',
      name: 'sampling',
      component: Sampling,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: true
      }
    },
    {
      path: '/tstrslt',
      name: 'testresult',
      component: TestResult,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login-tr',
      name: 'logintestresult',
      component: LoginTestResult,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/login-cnfrm',
      name: 'loginconfirm',
      component: LoginConfirm,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    },
    {
      path: '/login-ec',
      name: 'loginentercode',
      component: LoginEnterCode,
      meta: {
        requiresAuth: false,
        requiresCodeVerified: false
      }
    }
  ]
})

/* Route Guard */
router.beforeEach((to, from, next) => {
  handleSessionIdQueryParam()

  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (sessionStorage.getItem('jwt')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }

  if (to.matched.some(route => route.meta.requiresCodeVerified)) {
    if (sessionStorage.getItem('verificationCode') && sessionStorage.getItem('verificationCode').length === 6) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js